// @core/api/endpoints/signature/submit_signature.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SubmitSignatureRequest,
  SubmitSignatureResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Submit an internal qualified signature
 * Issues a certificate, signs the request content hash, validates the evidence, and completes the request and party.
 */
export async function SubmitSignature(
  request_id: string,
  data: SubmitSignatureRequest,
  options?: RequestOptions
): Promise<SubmitSignatureResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/requests/:request_id/submit`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.post<SubmitSignatureResponse>(requestPath, data, requestOptions);
}
